import { TotalLine } from './TotalLine';

interface IGrandTotalLine {
  grandTotal: number;
  totalText?: string;
}

export const GrandTotalLine = ({ grandTotal, totalText = 'Total' }: IGrandTotalLine) => (
  <TotalLine dataCy={'order-grand-total'} total={grandTotal} totalText={totalText} />
);
